import { Reveal } from "./Reveal";
import { copy } from "@/content";

export const Talent = ({ lang = "en" }) => {
  const t = copy[lang].talent;
  return (
    <section
      className="relative border-y border-dealer-ivory/10 bg-dealer-surface/40 py-28 sm:py-40"
      data-testid="featured-talent-section"
    >
      <div className="mx-auto max-w-[1600px] px-6 sm:px-10">
        <Reveal>
          <p className="dealer-eyebrow">REPRESENTED TALENT</p>
        </Reveal>

        <div className="mt-14 grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal delay={0.1}>
              <div className="relative">
                <div
                  aria-hidden="true"
                  className="absolute -left-3 -top-3 h-full w-full border border-dealer-ivory/15 sm:-left-4 sm:-top-4"
                />
                <img
                  src="/assets/daniele-portrait.jpg"
                  alt="Daniele Santarelli — editorial portrait"
                  loading="lazy"
                  data-testid="featured-talent-portrait-primary"
                  className="relative aspect-[4/5] w-full object-cover object-top"
                  style={{ filter: "saturate(0.85) contrast(1.05)" }}
                />
              </div>
            </Reveal>
          </div>

          <div className="flex flex-col justify-between lg:col-span-6 lg:col-start-7">
            <div>
              <Reveal delay={0.15}>
                <h3 className="font-serif text-3xl leading-[1.1] tracking-tight text-dealer-ivory sm:text-4xl lg:text-5xl">
                  DANIELE
                  <br />
                  SANTARELLI
                </h3>
              </Reveal>
              <Reveal delay={0.25}>
                <p className="mt-8 font-sans text-[11px] font-medium tracking-[0.3em] text-dealer-silver">
                  HEAD COACH
                </p>
                <p className="mt-2 font-sans text-[11px] font-medium tracking-[0.3em] text-dealer-burgundybright">
                  WORLD CHAMPION
                </p>
              </Reveal>
              <Reveal delay={0.35}>
                <p className="mt-10 max-w-lg text-sm font-light leading-relaxed text-dealer-silver sm:text-base">
                  {t.body}
                </p>
              </Reveal>
            </div>

            <Reveal delay={0.3} className="mt-14">
              <div className="max-w-md">
                <img
                  src="/assets/daniele-court.jpg"
                  alt="Daniele Santarelli coaching on court"
                  loading="lazy"
                  data-testid="featured-talent-portrait-action"
                  className="aspect-[16/10] w-full border border-dealer-ivory/10 object-cover object-top"
                  style={{ filter: "saturate(0.8) contrast(1.05)" }}
                />
                <p className="mt-4 font-sans text-[10px] tracking-[0.25em] text-dealer-subtle">
                  ON COURT — INTERNATIONAL COMPETITION
                </p>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
